module.exports = __webpack_public_path__ + "img/egypt.1db3981b.svg";